<template>
  <div id="stripe">
    <el-card>
      <h3>
        <img src="/static/images/visa.png" alt="VISA" />
        <img src="/static/images/amex.png" alt="AMEX" />
        <img src="/static/images/mastercard.png" alt="MASTERCARD" />
        Paiement sécurisé par carte bancaire
      </h3>

      <div v-if="!showPaiement" class="informations">
        Le client reconnaît que le traitement d'un dossier de résiliation constitue,
        du fait du choix opéré par le client sur l'identité de la personne concernée renseigné,
        la fourniture d'un bien personnalisé au sens de l'article L121-21-8,
        3° du Code de la consommation.<br><br>
        Dès lors, le client est expréssement informé qu'il ne peut pas, en
        application de ces dispositions, exercer son droit de rétractation
        sur l'achat d'un service de résiliation en ligne.
      </div>

      <div v-if="showPaiement">
        <el-form-item label="Votre numéro de carte">
          <card-number
            class="stripe-element card-number"
            ref="cardNumber"
            :stripe="$root.stripeKey"
            :options="options"
            @change="number = $event.complete"
          />
        </el-form-item>

        <el-row :gutter="25">
          <el-col :span="12">
            <el-form-item label="Date d'expiration">
              <card-expiry
                class="stripe-element card-expiry"
                ref="cardExpiry"
                :stripe="$root.stripeKey"
                :options="options"
                @change="expiry = $event.complete"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Cryptogramme visuel">
              <card-cvc
                class="stripe-element card-cvc"
                ref="cardCvc"
                :stripe="$root.stripeKey"
                :options="options"
                @change="cvc = $event.complete"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-alert
          v-if="showError"
          type="error"
          effect="dark"
          title="Les informations numéro de carte, date d'expiration ou CVC sont incorrect."
          :closable="false"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { CardNumber, CardExpiry, CardCvc } from 'vue-stripe-elements-plus'

export default {
  props: {
    stripeComplete: Boolean,
    showError: Boolean,
    showPaiement: Boolean
  },
  components: {
    CardNumber,
    CardExpiry,
    CardCvc
  },
  data () {
    return {
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      options: {}
    }
  },
  methods: {
    update () {
      this.complete = this.number && this.expiry && this.cvc

      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus()
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus()
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus()
        } else if (!this.number) {
          this.$refs.cardNumber.focus()
        }
      }

      this.$emit('update:stripeComplete', this.complete || false)
    }
  },
  watch: {
    number () {
      this.update()
    },
    expiry () {
      this.update()
    },
    cvc () {
      this.update()
    },
    showPaiement (value) {
      if (value) {
        this.$nextTick(() => document.getElementById('montant').scrollIntoView())
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  h3 {
    font-weight: 600;
    margin-top: 0;

    img {
      float: right;
      max-height: 23px;
      margin: 0 5px;
    }
  }
  .el-card {
    background: #F5F5F5;

    .informations {
      color: #707070;
      line-height: 18px;
      font-size: 13px;
      margin-bottom: 25px;
    }
  }

  @media (max-width: 767px) {
    h2 {
      font-size: 18px;
    }
  }
</style>

<style lang="scss">
  #stripe {
    text-align: left;

    .el-form-item__label {
      color: #00223B;
      width: 180px !important;
    }
    .el-form-item__content {
      margin-left: 180px !important;
    }
    .stripe-element .StripeElement {
      background-color: #fff;
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      border: 1px solid #DCDFE6;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: 13px;
      outline: none;
      padding: 2px 15px;
      -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;

      &.StripeElement--invalid {
        border: 1px solid #fa755a;
      }
    }
  }
  #stripe-card {
    padding: 12px 18px;
    background: white;
    border: 1px solid #00223B;
  }

  @media (max-width: 767px) {
    #stripe {
      .el-form-item__label {
        width: 100% !important;
        line-height: 22px;
        font-size: 12px;
      }
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/paiement/stripe.vue